import { Check, BedDouble, BedSingle } from "lucide-react";
import { BEGINNER_PRICES, RETREAT_INCLUDES, MONTHLY_PRICES, MONTHLY_INCLUDES } from "@/lib/constants";
import { BookCallButton } from "@/components/site/BookCall";

const ICONS = { twin: BedDouble, private: BedSingle };

function PriceCard({ p }) {
  const Icon = ICONS[p.id];
  const dark = p.id === "private";
  return (
    <div className={`rounded-2xl p-7 flex flex-col gap-3 border ${dark ? "bg-[#0B2A4A] text-[#F5ECD7] border-[#0B2A4A]" : "bg-white border-[#0B2A4A]/10"}`} data-testid={`price-card-${p.id}`}>
      <Icon className={`h-7 w-7 ${dark ? "text-[#F08A3C]" : "text-[#1A9AA8]"}`} />
      <h3 className={`text-lg font-semibold ${dark ? "text-white" : "text-[#0B2A4A]"}`}>{p.name}</h3>
      <p className="font-display text-4xl font-bold text-[#F08A3C]" data-testid={`price-${p.id}`}>{p.price}<span className={`ml-1 text-sm font-medium ${dark ? "text-[#F5ECD7]/70" : "text-slate-500"}`}>USD · 8 nights</span></p>
      <p className={`text-sm leading-relaxed ${dark ? "text-[#F5ECD7]/85" : "text-slate-600"}`}>{p.note}</p>
      {p.extra && <p className={`text-sm font-medium ${dark ? "text-white" : "text-[#0B2A4A]"}`}>Plus: {p.extra}</p>}
      <div className="mt-auto"><BookCallButton source={`retreat-${p.id}`} light={dark} className="w-full justify-center" testId={`price-reserve-btn-${p.id}`} label="Book a free call to reserve" /></div>
    </div>
  );
}

export function BeginnerPricing() {
  return (
    <section id="pricing" className="max-w-7xl mx-auto px-4 sm:px-8 py-10 scroll-mt-24" data-testid="beginner-pricing">
      <p className="font-mono-ui text-xs tracking-[0.3em] text-[#1A9AA8]">COURSE PRICES</p>
      <h2 className="mt-3 text-2xl sm:text-3xl font-bold tracking-tight text-[#0B2A4A]">The 7-day retreat at Esc Digital Nomad Village, Popoyo</h2>
      <p className="mt-3 max-w-2xl text-slate-600">Taught in person by Greg at Esc Digital Nomad Village. Choose your room, then book a free 20-minute call with Greg to reserve your dates.</p>
      <div className="mt-8 grid md:grid-cols-2 gap-5">{BEGINNER_PRICES.map((p) => <PriceCard key={p.id} p={p} />)}</div>
      <div className="mt-6 rounded-2xl bg-[#F5ECD7] p-7" data-testid="retreat-includes">
        <h3 className="font-semibold text-[#0B2A4A]">Both retreat rooms include — Esc Digital Nomad Village, Popoyo, Nicaragua</h3>
        <ul className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2 text-sm text-slate-700">
          {RETREAT_INCLUDES.map((t) => <li key={t} className="flex gap-2"><Check className="h-4 w-4 mt-0.5 text-[#1A9AA8] shrink-0" />{t}</li>)}
        </ul>
      </div>
      <Monthly />
    </section>
  );
}

function Monthly() {
  return (
    <div className="mt-10 rounded-3xl bg-[#0B2A4A] text-[#F5ECD7] p-7 sm:p-10" data-testid="monthly-options">
      <p className="font-mono-ui text-xs tracking-[0.3em] text-[#F08A3C]">STAY THE MONTH AT Esc</p>
      <h3 className="mt-3 text-2xl font-bold text-white">Monthly retreat: choose it in week 1, build it in weeks 2–4</h3>
      <p className="mt-2 max-w-2xl text-sm text-[#F5ECD7]/80">Do the 7-day course, then stay at Esc Digital Nomad Village to build your chosen income avenue with daily check-ins and weekly targets. Monthly stays are arranged personally with Greg — book a free 20-minute call to reserve.</p>
      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        {MONTHLY_PRICES.map((m) => (
          <div key={m.id} className="rounded-2xl bg-white/5 ring-1 ring-white/15 p-5" data-testid={`price-card-${m.id}`}>
            <p className="font-semibold text-white">{m.name}</p>
            <p className="mt-1 font-display text-3xl font-bold text-[#F08A3C]" data-testid={`price-${m.id}`}>{m.price}<span className="ml-1 text-sm font-medium text-[#F5ECD7]/70">USD · 30 nights</span></p>
          </div>
        ))}
      </div>
      <ul className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2 text-sm">
        {MONTHLY_INCLUDES.map((t) => <li key={t} className="flex gap-2"><Check className="h-4 w-4 mt-0.5 text-[#1A9AA8] shrink-0" />{t}</li>)}
      </ul>
      <div className="mt-6"><BookCallButton source="monthly" light testId="monthly-book-call-btn" label="Book a free call to reserve a month" /></div>
    </div>
  );
}
